import React, { useContext } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import LabsDetails from "./LabsDetails";
import { checkRole } from "../../util/FormUtils";
import GroupApprovers from "../FieldTags/GroupApprovers";

const newPlan = window.location.pathname === "/xplans/new";

const Labs = ({ labs, labsAddress, handleChange, xplans, labsDetails, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.BIOLOGIST, ROLES.APPROVER]);
    const filteredOptions = Object.values(labsDetails)
        .filter(lab => !!lab.ExPlan)
        .sort((a, b) => a.LabName.localeCompare(b.LabName));

    return (
        <div id="labs" style={{ display: "flex", flexDirection: "column" }}>
            <div className="planField">
                <GroupApprovers />
                <Autocomplete
                    name="labs"
                    autoHighlight
                    options={filteredOptions}
                    getOptionLabel={(option) => `${option.LabName}${option.LabDesc ? ` (${option.LabDesc})` : ""}`}
                    value={labs ? Object.values(labsDetails).find(lab => lab.LabCode.toString() === labs.toString()) : null}
                    onChange={(_, newValue) => handleChange("labs", newValue ? newValue.LabCode : null)}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label={xplanLabels.labs}
                            InputLabelProps={{
                                shrink: true,
                                required: required.includes("labs")
                            }}
                            required={required.includes("labs")}
                        />
                    }
                    disabled={!canEdit}
                />
                {!newPlan && <HistoryLogElement xplans={xplans} label={"labs"} />}
            </div>
            {(labs && labsDetails[labs]) && (
                <div className="planField" style={{ marginTop: "16px" }}>
                    <div className="notVisible">
                        <GroupApprovers />
                    </div>
                    <LabsDetails lab={labsDetails[labs]} />
                </div>
            )}
            {(labsAddress || (labs && !labsDetails[labs])) && (
                <div className="planField" style={{ marginTop: "16px" }}>
                    <div className="notVisible">
                        <GroupApprovers />
                    </div>
                    <TextField
                        label="Legacy Lab Details"
                        multiline
                        InputProps={{ readOnly: true }}
                        value={
                            labsAddress
                                ? labs
                                    ? !labsDetails[labs]
                                        ? labs + "\n" + labsAddress
                                        : labsAddress
                                    : labsAddress
                                : labs && !labsDetails[labs]
                                    ? labs
                                    : ""
                        }
                    />
                </div>
            )}
        </div>
    );
};

export default Labs;
